import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { settingsItemSx, StyledSwitch } from 'framework/ui/layout';
import usePayrollReportSettings from 'domain/finance/payroll/generatedPayrolls/shared/Settings/usePayrollReportSettings';
import { useListContext } from 'framework/list';

const PayrollReportStateToggler = () => {
  const { setIsLatestReportsVisibleOnly, isLatestReportsVisibleOnly } = usePayrollReportSettings();
  const { loading } = useListContext();

  const onChangeCallback = (event: any) => {
    setIsLatestReportsVisibleOnly(event.target.checked);
  };

  return (
    <FormControlLabel
      className="payroll-report-settings-item"
      sx={settingsItemSx}
      control={
        <StyledSwitch
          color="primary"
          onChange={onChangeCallback}
          checked={isLatestReportsVisibleOnly}
          dataOn="Yes"
          dataOff="No"
          disabled={loading}
        />
      }
      label="Show only the latest payroll reports"
    />
  );
};

export default PayrollReportStateToggler;
